import axios from 'axios';
import { auth } from '../config/firebase';

const api = axios.create({
  baseURL: 'https://api.winal.app/api'
});

// Interceptor — agrega el email del usuario en cada request
api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user?.email) {
    config.headers['x-user-email'] = user.email;
  }
  return config;
});

// ── Legado (CRM, sin uso hoy pero no rompe nada) ──────────────────────────
export const getWorkspaces = async () => {
  const res = await api.get('/workspaces');
  return res.data;
};

export const getOpportunities = async (workspaceId) => {
  const res = await api.get(`/opportunities/workspace/${workspaceId}`);
  return res.data;
};

export const getLeads = async (workspaceId) => {
  const res = await api.get(`/leads/workspace/${workspaceId}`);
  return res.data;
};

export const getUsers = async (workspaceId) => {
  const res = await api.get(`/users/workspace/${workspaceId}`);
  return res.data;
};

export const getProducts = async (workspaceId) => {
  const res = await api.get(`/products/workspace/${workspaceId}`);
  return res.data || [];
};

export const getUserByEmail = async (email) => {
  const res = await api.get(`/users/email/${encodeURIComponent(email)}`);
  return res.data;
};

export const inviteUser = async (data) => {
  const res = await api.post('/users/invite', data);
  return res.data;
};

export const deactivateUser = async (id) => {
  const res = await api.put(`/users/${id}/deactivate`);
  return res.data;
};

// ── Nuevo — Winal eventos ──────────────────────────────────────────────────

export const bootstrapUser = async (email, name) => {
  const res = await api.post('/users/bootstrap', { email, name });
  return res.data;
};

export const linkPhone = async (phone) => {
  const res = await api.post('/users/link-phone', { phone });
  return res.data;
};

export const requestBusiness = async (note) => {
  const res = await api.post('/users/request-business', { note });
  return res.data;
};

export const getBusinessRequests = async () => {
  const res = await api.get('/users/business-requests');
  return res.data;
};

export const approveBusiness = async (id) => {
  const res = await api.put(`/users/${id}/approve-business`);
  return res.data;
};

export const rejectBusiness = async (id) => {
  const res = await api.put(`/users/${id}/reject-business`);
  return res.data;
};

export const setEventLimit = async (id, monthlyEventLimit) => {
  const res = await api.put(`/users/${id}/event-limit`, { monthlyEventLimit });
  return res.data;
};

export const getAllUsersAdmin = async () => {
  const res = await api.get('/users/admin/all');
  return res.data;
};

export const getMyEvents = async () => {
  const res = await api.get('/events/mine');
  return res.data;
};

export const getOpenEvents = async () => {
  const res = await api.get('/events/open');
  return res.data;
};

export const joinEventApi = async (id) => {
  const res = await api.put(`/events/${id}/join`);
  return res.data;
};

export const leaveEventApi = async (id) => {
  const res = await api.put(`/events/${id}/leave`);
  return res.data;
};

export const getAllEvents = async () => {
  const res = await api.get('/events/all');
  return res.data;
};

export const createEvent = async (data) => {
  const res = await api.post('/events', data);
  return res.data;
};

export const cancelEvent = async (id) => {
  const res = await api.put(`/events/${id}/cancel`);
  return res.data;
};

export const updateEventApi = async (id, data) => {
  const res = await api.put(`/events/${id}`, data);
  return res.data;
};

export const createCourt = async (data) => {
  const res = await api.post('/venues/courts', data);
  return res.data;
};

export const updateCourt = async (id, data) => {
  const res = await api.put(`/venues/courts/${id}`, data);
  return res.data;
};

export const getMyCourts = async () => {
  const res = await api.get('/venues/courts/mine');
  return res.data;
};

export const deleteCourt = async (id) => {
  const res = await api.delete(`/venues/courts/${id}`);
  return res.data;
};

export const generateSlots = async (id) => {
  const res = await api.post(`/venues/courts/${id}/generate`);
  return res.data;
};

export const getCustomerRecurrence = async () => {
  const res = await api.get('/venues/customers');
  return res.data;
};

export const updateBusinessProfile = async (data) => {
  const res = await api.put('/users/business-profile', data);
  return res.data;
};

export const getUsageSummary = async () => {
  const res = await api.get('/usage/summary');
  return res.data;
};

export default api;